(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-collection-head"] && !Shopify.designMode) return;
  try {
    
  /**
   * Keeps the free-shipping meter in the collection header true after a
   * quick add: when the cart changes, the section is fetched again and only
   * the meter is swapped.
   */
  if (!customElements.get('sk-ship-live')) {
    class SkShipLive extends HTMLElement {
      #controller = new AbortController();

      connectedCallback() {
        document.addEventListener(
          'shopify:cart:lines-update',
          (event) => {
            const done = /** @type {any} */ (event).promise;
            Promise.resolve(done)
              .catch(() => {})
              .then(() => this.refresh());
          },
          { signal: this.#controller.signal }
        );
      }

      disconnectedCallback() {
        this.#controller.abort();
      }

      async refresh() {
        const id = this.dataset.sectionId;
        if (!id) return;
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', id);
          const response = await fetch(url.toString());
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fresh = html.querySelector('sk-ship-live');
          if (fresh) this.innerHTML = fresh.innerHTML;
        } catch (error) {
          /* The meter keeps its last value; the cart drawer shows the truth. */
        }
      }
    }
    customElements.define('sk-ship-live', SkShipLive);
  }

  } catch(e) { console.error(e); }
})();
})();
